export default "__VITE_ASSET__C255Nbi4__"